import buttonMenu from '../../assets/setup/tutorial_button_menu.png';
import { WarningAlert } from "src/components/WarningAlert";

// component props interface 
interface Props {
    isMobileView: boolean;
}


export const StopResetButtons: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center  gap-y-1">
            <p>Access the button menu to stop, block, unblock, or reset buttons.</p>
            <WarningAlert message="<a href='https://christinak.itch.io/deck-hopper-advanced'>Deck Hopper Advanced</a></strong> extension must be installed and running for block and unblock features." />

            {/* Mobile Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Mobile</h2>
                <ul className="list-disc list-inside">
                    <li>Switch to 'Settings Mode' mode by tapping the eye icon on the navigation bar or by tapping the floating Hopper button. Then, tap on a button for button menu.
                        <img className="mt-2 mb-3" src={buttonMenu} alt="Button Menu" width="300" />
                    </li>
                </ul>
            </div>

            {/* Desktop Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Desktop</h2>
                <ul className="list-disc list-inside">
                    <li>Right click on a button for button menu.</li>
                </ul>
            </div>
        </div>
    )
}